import CommonResult from 'app/components/OrderPayment/Common/CommonResult';
import React from 'react';

const PaypalResult = () => {
  return <CommonResult />;
};

export default PaypalResult;
